import { Component, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult, HttpPaginator } from 'src/app/models/base-http-response';
import { FormControl, FormGroup } from '@angular/forms';
import { ParametroSistema } from 'src/app/models/parametrosistema.model';
import { Enum } from 'src/app/models/enum.model';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-parametros-component',
  templateUrl: './parametros-component.html'
})
export class ParametrosComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
  public placeHolderLingua: any = {
    description: "<Selecionar>",
    id: 0,
  };
  public customMsgService: CustomMessagesService;
  public formGroup: FormGroup = new FormGroup({});
  constructor(public msgService: MessageService, private dialogService: DialogService, private api: ApiService,
    private notificationService: NotificationService) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.formGroup = new FormGroup({
      UrlRecuperacaoPwd: new FormControl(['']),
      EmailFrom: new FormControl(['']),
      EmailPassword: new FormControl(['']),
      EmailPort: new FormControl(['']),
      EmailSmtpServer: new FormControl(['']),
      Lingua: new FormControl(['']),
      EmailUsername: new FormControl(['']),
    });
  }
  public ngOnInit(): void {
    this.load();
  }

  public parametros: Array<ParametroSistema> = [];
  public linguas: Array<Enum> = [];

  load() {
    this.api
      .getRequest<BaseHttpResponse<Enum[]>>("Utilizador/GetLinguas")
      .then((data) => {
        this.linguas = data.value;
      })
      .catch((err) => { });
    this.api.crudGet<HttpPaginator<ParametroSistema>>(
      'Parametros').then(data => {
        this.parametros = data.data;
        this.parametros.forEach(x => {
          if (x.chave == 'Lingua')
            this.formGroup.controls[x.chave]?.setValue({ id: Number(x.valor) });
          else
            this.formGroup.controls[x.chave]?.setValue(x.valor);
        });
      });
  }

  cancelChanges() { }

  saveChanges() {
    this.parametros.forEach(element => {
      if (element.chave == 'Lingua')
        element.valor = this.formGroup.controls[element.chave]?.value.id;
      else
        element.valor = this.formGroup.controls[element.chave]?.value;
    });
    this.api.save<BaseHttpResult>('Parametros/BatchSave', this.parametros).then(res => {
      if (res.ok) {

        this.notificationService.show({
          content: this.customMsgService.translate('registoGravadoComSucesso'),
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });
      } else {
      }
    });
  }
}
